import React from 'react';
export var SpinnerIcon = function SpinnerIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "codacy-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill-none stroke-width",
    d: "M258.28 96a160 160 0 10160 160",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }));
};